var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.uid + '',staticClass:"search-item"},[_vm._t("before"),_c('span',{class:{ske: _vm.ske, 'forced-ske': _vm.forcedSke}},[_vm._v("\n    "+_vm._s(_vm.domainname)+"\n  ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }